export default{
    c1:"There are no tasks. Please pay with coupons",
    c2:"Back",
}